/**
 * productLinkBuilder
 * Builds a product URL from the pre-computed productSlug stored in Commerce Tools / Algolia.
 * The slug is no longer computed client-side; it is sourced directly from the API (AC5).
 *
 * @param productSlug: string  - normalised slug from Commerce Tools / Algolia
 * @param itemcode: string
 * @param giftFlag: boolean
 * @returns string
 */
import { globals } from 'common-ui';

export const productLinkBuilder = (
  productSlug: string | undefined,
  itemcode: string | undefined,
  giftFlag = false,
): string => {
  if (!itemcode) {
    return '';
  }
  if (giftFlag && globals.brandId !== 'avy' && globals.country === 'uk') {
    return productSlug ? `/gifts/product/${productSlug}/${itemcode}` : `/gifts/product/${itemcode}`;
  }
  return productSlug ? `/product/${productSlug}/${itemcode}` : `/product/${itemcode}`;
};
